<template>

  <div v-loading="loading">

    <div v-infinite-scroll="loadMore"
         infinite-scroll-disabled="busy" infinite-scroll-distance="10">
      <div :class="{'slats': true, 'highlight': highlightForm == item._id}" v-for="item in dataItems" :key="item._id">

        <div class="size3of4 unit clickable" @click="onRowClick(item)">

          <div class="size5of8 unit">

            <form-icon :form="item" />

            <div class="form-title">{{item.title}}</div>

            <div class="form-description">{{item.description}}</div>

          </div>


          <div class="size3of8 unit">

            <div class="data">

              <div v-if="item.filledCount">
                <h4>{{item.filledCount}}</h4>
                <span class="text-muted">submissions</span>
              </div>
              <div v-else>
                <h4 class="text-muted">0</h4>
                <span class="text-muted">submissions</span>
              </div>

            </div>

            <div class="data">

              <div v-if="item.lastFilledForm">
                <h4>{{formatTimeAgo(item.lastFilledForm)}}</h4>
                <span class="text-muted">ago</span>
              </div>
              <div v-else>
                <h4 class="text-muted">no</h4>
                <span class="text-muted">activity</span>
              </div>

            </div>

          </div>


        </div>
        <div class="size1of4 unit text-right">

          <form-actions :form="item" @on-settings="onFormSettings" />

        </div>

      </div>

      <div class="text-muted loading-list" v-if="!isFullList && loading">
        <span class="el-icon-loading"></span>
        Loading...
      </div>
      <div class="text-center loading-list" v-if="!isFullList && !loading">
        <a href="" @click.prevent="loadMore" class="text-muted">
          <span class="el-icon-arrow-down"></span>
          More...
        </a>
      </div>
    </div>
  </div>

</template>
<style lang="scss">
  @keyframes highlight {
    0% {
      background: #f0f9eb;
    }
    100% {
      background: transparent;
    }
  }

  .slats.highlight {
    animation: highlight 2s ease-in-out;
  }
  .filter-header {
    margin: 10px 0;
  }

  .sort-container {
    line-height: 36px;
    font-size: 14px;
  }
  .filter-dropdown {
    border-bottom: 1px dotted #aaa;
    font-size: 100%;
    line-height: 24px;
  }

  .slats {
    padding: 17px 0;
    border-bottom: 1px solid rgba(35, 35, 35, .1);

    &:before, &:after {
      content: " ";
      display: table;
      clear: both;
    }
  }
  .loading-list {
    padding: 17px 0;
    text-align: center;
  }

  .clickable {
    cursor: pointer;
  }

  .el-table__row .cell {
    overflow: visible;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .b-filters {
    background-color: #f8f9fa;
    border-radius: 5px;
    padding: 0.5rem 1rem;
  }

  .size1of4 {
    width: 25%;
  }

  .size3of4 {
    width: 75%;
  }

  .size5of8 {
    width: 62.5%;
  }

  .size3of8 {
    width: 37.5%;
  }

  .unit {
    overflow: hidden;
    background-clip: padding-box !important;
    float: left;
  }

  h4 {
    font-size: 17px;
    line-height: 24px;
  }

  .data {
    float: left;
    padding-left: 30px;

    h4 {
      margin: 0;
    }
  }

  .text-right {
    text-align: right;
  }

  @media screen and (max-width: 40em) {
    .size1of2, .size1of3, .size1of4, .size2of3, .size2of4, .size3of4, .size3of8, .size4of8, .size5of8, .size7of8 {
      width: 100%
    }
  }
</style>
<script>
  import moment from 'moment';
  import FormIcon from 'components/Forms/Icon';
  import FormActions from 'components/Forms/Actions';


  export default {
    props: [],
    components: {
      FormIcon,
      FormActions
    },
    data() {
      const highlightForm = localStorage.highlightFormId;
      delete localStorage.highlightFormId;
      return {
        highlightForm,
        busy: false
      }
    },
    async mounted() {
      await this.$store.dispatch('loadForms');
    },
    computed: {
      loading() {
        return this.$store.state.formsLoading;
      },
      page() {
        return this.$store.state.formsPage;
      },
      isFullList() {
        return this.$store.state.isFormsFullList;
      },
      currentSorting() {
        return this.$store.state.formsSorting;
      },
      dataItems() {
        return this.$store.state.forms;
      },
      totalItems() {
        return this.$store.state.totalForms;
      }
    },
    methods: {
      changeSorting(command) {
        this.$store.state.formsSorting = command;
      },
      onFormSettings(item) {
        this.$emit('form-settings', item);
      },
      async onDuplicate(item) {
        try {
          const { value } = await this.$prompt('Please input new title of form', 'Duplicate form', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[\w+]/,
            inputValue: item.title,
            inputErrorMessage: 'Invalid title'
          });

          const result = await this.$axios.post(`/v1/forms/${item._id}`, { title: value });

          this.$message.success('Form duplicated');
          await this.$store.dispatch('loadForms');
        } catch (err) {
          this.$message.error(err.toString());
        }
      },
      async loadMore() {
        await this.$store.dispatch('loadFormsPage');
      },
      onRowClick(item) {
        this.$router.push({ name: 'FormSubmissions', params: { id: item._id } })
      },
      formatTimeAgo(date) {
        return moment(date).fromNow(true);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// formsList.vue?32ba5ad2